// @flow
export const filterId: 'foodMode' = 'foodMode';
